import type { FC } from 'react';
import { Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router';

const MATHeader: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { dpid } = useParams<'dpid'>();
  const tab = pathname.includes('/mat-discovery') ? 1 : 0;

  const handleChange = (_: any, v: number) => {
    if (!dpid) return;
    if (v === 0) navigate(`/data-pools/${dpid}/mat`);
    else navigate(`/data-pools/${dpid}/mat-discovery`);
  };

  return (
    <div style={{ borderBottom: '1px solid #BDC3D2', padding: '0 20px' }}>
      <Tabs
        value={tab}
        onChange={handleChange}
        aria-label="MAT sections"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="MAT Data" />
        <Tab label="MAT Discovery" />
      </Tabs>
    </div>
  );
};

export default MATHeader;
